<div class="compliance-wrapper">
	<div class="compliance-outer">
		<h2 class="compliance-header text-center mb-4">
			Enhancing Security through Digital <br class="d-none d-md-block" />
			Partnerships
		</h2>
		<p class="ready-set-content text-center mb-5">
			Join our ecosystem of partners to make the world a safer place
			through <br class="d-none d-md-block" />
			compliance. No contribution is too small and together, we can all
			make a <br class="d-none d-md-block" />
			difference and reimagine a better world where compliance is cheaper,
			<br class="d-none d-md-block" />
			easier, and more effective. 
		</p>
	</div>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="container text-center">
				<div class="row">
					<div
						class="
							col-md-4
							mb-5 mb-lg-0
							d-flex
							flex-column
							justify-content-between
						"
					>
						<div>
							<img
								class="challenges-list-img"
								src="../../assets/img/resellers.svg"
								alt=""
							/>
							<div class="challenges-list-head">Resellers</div>
							<div class="challenges-list-content">
								Share in our success. Click the button
								<br class="d-none d-xl-block" />
								below to contact Carahsoft to register
								<br class="d-none d-xl-block" />
								Federal opportunities.
							</div>
						</div>

						<a
							href="https://www.carahsoft.com/regscale#overview"
							target="_blank"
						>
							<button class="complaince-button py-2 px-5 mt-5">
								Visit CARAHSOFT
							</button></a
						>
					</div>
					<div
						class="
							col-md-4
							mb-5 mb-lg-0
							d-flex
							flex-column
							justify-content-between
						"
					>
						<div>
							<img
								class="challenges-list-img"
								src="../../assets/img/integrators.svg"
								alt=""
							/>
							<div class="challenges-list-head">Integrators</div>
							<div class="challenges-list-content">
								Make your compliance data real-time by
								<br class="d-none d-xl-block" />
								leveraging an existing integration or building
								<br class="d-none d-xl-block" />
								your own within our APIs and CLI
								<br class="d-none d-xl-block" />
								ecosystem.
							</div>
						</div>

						<a
							href="https://regscale.com/documentation/apis"
							target="_blank"
						>
							<button class="complaince-button py-2 px-5 mt-5">
								View our APIs
							</button></a
						>
					</div>
					<div
						class="
							col-md-4
							mb-5 mb-lg-0
							d-flex
							flex-column
							justify-content-between
						"
					>
						<div>
							<img
								class="challenges-list-img"
								src="../../assets/img/auditors.svg"
								alt=""
							/>
							<div class="challenges-list-head">
								Auditors and Service Providers
							</div>
							<div class="challenges-list-content">
								Maximize profits and win more work using
								<br class="d-none d-xl-block" />
								the RegScale platform to deliver your
								<br class="d-none d-xl-block" />
								compliance services more efficiently.
							</div>
						</div>

						<a [routerLink]="['/contact']">
							<button class="complaince-button py-2 px-5 mt-5">
								Contact Us
							</button></a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
